
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/s/kn/[static]",
      function () {
        return require("private-next-pages/cleartax.in/s/kn/[static]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/s/kn/[static]"])
      });
    }
  